<template>
    <div>
    <div class="container-lg page page--padding-top page--padding-bottom">
        <div class="row">
            <div class="col-md-6">
                <div class="copy mb-4 mb-sm-0">
                    <h4>Search</h4>
                    <p>Please use the form below to access seed treatment and quality information from our database.</p>
                    <form v-on:submit="performSearch" class="">
                      <!-- v-on:input="validateSearchInput()" -->
                        <div class="input-group input-group--search">
                          <input v-model="search"
                          class="form-control form-control-lg"
                          placeholder="Enter batch number here"
                          aria-label="Batch Number"
                          aria-describedby="search"
                          type="text"
                          maxlength="10"
                          v-on:keypress="preventNonNumericalInput()"
                          >
                          <div class="input-group-append">
                            <button v-on:click="performSearch"
                            class="btn btn-primary d-flex align-items-center pr-3"
                            type="button">
                            <i class="material-icons-round mr-1">search</i> Search
                          </button>
                        </div>
                      </div>
                      <!-- <p class="error" >Please enter 10 digits or less</p> -->
                    </form>
                  </div>
            </div>
            <div class="col-md-6">
                <div v-if="loading" class="v-spinner-container p-5 d-flex justify-content-center align-items-center">
                    <vue-spinner></vue-spinner>
                </div>
                <template v-else-if="!validSearch">
                    <h4>Seed quality data results</h4>
                    <p>Please enter a batch number</p>
                </template>
                <template v-else-if="!_.get(results, 'data.length')">
                    <h4>No results found.</h4>
                    <p>
                        We&#39;re not currently able to retrieve data for the batch you&#39;ve scanned&#47;searched.
                        <br>
                        Click on “Alert Us” below and our team will look into the missing batch on
                        the system.
                    </p>
                    <p>
                        Enter your email address to be notified when the seed quality
                        information is available online.
                    </p>
                    <div v-if="formStatus == 'error'" class="alert alert-danger alert-dismissable fade show" id="form-error" role="alert">
                        {{ formError }}
                    </div>
                    <div v-if="formStatus == 'submitted'" class="alert alert-success">
                        Your request has been submitted.
                    </div>
                    <div v-else-if="formStatus == 'submitting'" class="v-spinner-container p-5 d-flex justify-content-center align-items-center">
                        <vue-spinner></vue-spinner>
                    </div>
                    <form v-else ref="form" class="row">
                        <div class="col-md-6">
                            <div class="input-group input-group">
                                <input v-model="form.email"
                                    type="email"
                                    placeholder="Your Email*"
                                    aria-label="Your Email"
                                    class="form-control form-control-lg"
                                    required>
                            </div>
                        </div>
                        <div class="col-md-6 pl-md-0">
                            <div class="input-group input-group--search">
                                <input v-model="form.batch_number"
                                    required
                                    placeholder="Batch Number"
                                    aria-label="Batch Number"
                                    class="form-control form-control-lg"
                                    type="number"
                                    maxlength="10"
                                    v-on:keypress="preventNonNumericalInput()"
                                    >
                                    
                                <div class="input-group-append">
                                    <button ref="form-btn"
                                        type="button"
                                        class="btn btn-primary d-flex align-items-center pr-3"
                                        >
                                        Alert Us
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>
                <template v-else>
                    <h4>Seed quality data results</h4>
                    <p>This information is provided to assist you in setting your desired planting rate. In addition to this information please remember to factor in a field loss percentage that may apply to your particular situation.</p>

                    <div v-for="item in resultData" :key="item.type + item.id" class="py-3">
                        <table class="table table-bordered">
                            <colgroup>
                                <col width="40%">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td>Batch number</td>
                                    <td>{{ _.get(item, 'attributes.batch_number') }}</td>
                                </tr>
                                <tr>
                                    <td>Hybrid</td>
                                    <td>{{ _.get(item, 'attributes.hybrid') }}</td>
                                </tr>
                                <tr>
                                    <td>Seed count per kg</td>
                                    <td>{{ _.get(item, 'attributes.seed_count') }}</td>
                                </tr>
                                <tr>
                                    <td>Germination percentage</td>
                                    <td>{{ _.get(item, 'attributes.germination') }}</td>
                                </tr>
                                <tr>
                                    <td>Test date</td>
                                    <td>{{ _.chain(item).get('attributes.test_date').str(['date']).value() }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p>The germination value above is provided from a 7 day warm germination test conducted on a representative sample of this batch stored at a GenTech Seeds location on the date specified. If you have held this seed for over 12 months, best practise would be to have this seed retested. Please contact your GenTech Seeds representative to arrange for a retest at no additional cost.</p>
                </template>
            </div>
        </div>
    </div>
    </div>
</template>
<script charset="utf-8">
import VueSpinner from 'vue-spinner/src/MoonLoader.vue';
import UtilsMixin from './UtilsMixin';

export default {
    data() {
        let params = new URLSearchParams(window.location.search);
        return {
            loading: false,
            search: params.get('batch_number'),
            results: null,
            currentType: null,
            validSearch: false,
            form: {
                batch_number: params.get('batch_number'),
                email: null,
                token: null,
            },
            formStatus: null,
            formError: null,
            recaptchaId: null,
        }
    },

    mixins: [UtilsMixin],

    components: {
        VueSpinner
    },

    created() {
        if(this.search){
            this.performSearch();
        }
    },

    mounted() {
    
    },

    watch: {
        loading(newVal) {
            if (!newVal) {
                this.$nextTick(() => {
                    this.registerRecaptcha();
                })
            }
        }
    },

    computed: {
        $search() {
            return $('#search');
        },

        resultData() {
            return _.chain(this.results)
                .get('data', [])
                .value();
        }
    },

    methods: {
    performSearch(e = null) {
        if (e) {
            e.preventDefault();
        }
        if(!this.search){
            return false;
        }

        this.validSearch = false;
        this.loading = true;
        this.api.getData('/hybrid_batches', {
            search: this.search
        }).then(res => {
            this.results = res;
        }).finally(() => {
            this.loading = false;
            this.validSearch = true;
            this.form.batch_number = this.search;
            window.history.pushState(null, null, `?batch_number=${this.search || ''}`)
        })
    },

    preventNonNumericalInput(evt) {
      // allow numbers and D character only
      evt = (evt) ? evt : window.event;
          let keyCode = evt.code;

          let validKeyCodes = [
              'Digit0',
              'Digit1',
              'Digit2',
              'Digit3',
              'Digit4',
              'Digit5',
              'Digit6',
              'Digit7',
              'Digit8',
              'Digit9',
              'Numpad0',
              'Numpad1',
              'Numpad2',
              'Numpad3',
              'Numpad4',
              'Numpad5',
              'Numpad6',
              'Numpad7',
              'Numpad8',
              'Numpad9',
          ];

          if(!_.includes(validKeyCodes, keyCode)) {
              evt.preventDefault();
          } else {
              return true;
          }
        },

        submitForm(token) {

            let form = this.$refs['form'];
            if (form.reportValidity()) {
                this.formStatus = 'submitting';
                this.api.postData('/hybrid_batch_requests', {}, {
                    email: this.form.email,

                    // validate batch number 
                    batch_number: this.form.batch_number,
                    token: token,
                }).then((res) => {
                    this.formStatus = 'submitted';
                    this.formError = null;
                }).catch((e) => {
                  
                  this.formStatus = 'error';
                  this.formError = _.get(e, 'response.data.message', 'Please check form data');

                    this.$nextTick(() => {
                        this.initRecaptchaButton();
                    })
                })
            }
        },

        getRecaptchaKey() {
            return window.env.GOOGLE_RECAPTCHA_KEY;
        },

        registerRecaptcha() {
            if (_.get(window.grecaptcha, 'render')) {
                this.initRecaptchaButton();
            }
            window.addEventListener('recaptcha-init', () => {
                this.initRecaptchaButton();
            })
        },

        initRecaptchaButton() {
            this.recaptchaId = grecaptcha.render(this.$refs['form-btn'], {
                sitekey: this.getRecaptchaKey(),
                callback: this.submitForm,
            });
        },
    },
}
</script>
